import { render, staticRenderFns } from "./AvailableChannelsRenderer.vue?vue&type=template&id=987f6b22&scoped=true"
import script from "./AvailableChannelsRenderer.vue?vue&type=script&lang=js"
export * from "./AvailableChannelsRenderer.vue?vue&type=script&lang=js"
import style0 from "./AvailableChannelsRenderer.vue?vue&type=style&index=0&id=987f6b22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987f6b22",
  null
  
)

export default component.exports